import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { InvitationFragment } from "@/v2-backoffice-client/invitation/__types__/invitation.fragment"
import InvitationUpdateDialog from "@/v2-backoffice-client/invitation/update/InvitationUpdateDialog"

export type InvitationUpdateMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  invitation: InvitationFragment
}

function InvitationUpdateMenuItem(props: InvitationUpdateMenuItemProps) {
  const { invitation, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="pencil"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Update Invitation"}
      </ActionMenu.Item>

      <InvitationUpdateDialog
        invitation={invitation}
        open={isOpen}
        onOpenChange={setIsOpen}
      />
    </>
  )
}

export default InvitationUpdateMenuItem
